import { Form, Formik } from "formik";
import "moment-timezone";
import React, { Component } from "react";
import { Button, Checkbox, Modal } from "react-bootstrap";
import AuthContext from "../auth-context";

class RescheduleAsNewDealModal extends Component {
  static contextType = AuthContext;

  render() {
    const { showModal, onCloseModal, actions } = this.props;
    const authStore = this.context;
    const isAdmin = authStore.hasRole("admin");

    const reschedule = (
      create_new_deal,
      assign_deal_to_me,
      admin_resheduling
    ) => {
      actions.tcsReschedule(
        create_new_deal,
        assign_deal_to_me,
        admin_resheduling
      );
    };

    return (
      <Modal show={showModal} onHide={onCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Reschedule as New Deal</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{ assign_deal_to_me: false }}
            // onSubmit={reschedule}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              reschedule(true, values["assign_deal_to_me"], isAdmin);
            }}
            render={({ isSubmitting, setFieldValue, values }) => (
              <Form>
                <Checkbox
                  checked={values.assign_deal_to_me}
                  onChange={() =>
                    setFieldValue(
                      "assign_deal_to_me",
                      !values.assign_deal_to_me
                    )
                  }
                >
                  Assign TCS to me?
                </Checkbox>

                <div className="clearfix">
                  <Button
                    className="pull-right"
                    disabled={isSubmitting}
                    type="submit"
                    bsStyle="info"
                    bsSize="small"
                  >
                    Reschedule
                  </Button>
                </div>
              </Form>
            )}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

export default RescheduleAsNewDealModal;
